__turbopack_context__.v({
  "actions": "cart-drawer-summary-module__hiHQ5a__actions",
  "badges": "cart-drawer-summary-module__hiHQ5a__badges",
  "breakdown": "cart-drawer-summary-module__hiHQ5a__breakdown",
  "checkout": "cart-drawer-summary-module__hiHQ5a__checkout",
  "checkoutContent": "cart-drawer-summary-module__hiHQ5a__checkoutContent",
  "checkoutSpinner": "cart-drawer-summary-module__hiHQ5a__checkoutSpinner",
  "checkoutSpinnerRotate": "cart-drawer-summary-module__hiHQ5a__checkoutSpinnerRotate",
  "disabled": "cart-drawer-summary-module__hiHQ5a__disabled",
  "savingsRow": "cart-drawer-summary-module__hiHQ5a__savingsRow",
  "shippingRow": "cart-drawer-summary-module__hiHQ5a__shippingRow",
  "srOnly": "cart-drawer-summary-module__hiHQ5a__srOnly",
  "summary": "cart-drawer-summary-module__hiHQ5a__summary",
  "totalRow": "cart-drawer-summary-module__hiHQ5a__totalRow",
  "totalValue": "cart-drawer-summary-module__hiHQ5a__totalValue",
  "trust": "cart-drawer-summary-module__hiHQ5a__trust",
  "trustLabel": "cart-drawer-summary-module__hiHQ5a__trustLabel",
});
